export const createMarkup = (html, stripParagraphs = true) => {
  html = html || ''
  if (stripParagraphs) {
    html = html.replace('<p>', '')
    html = html.replace('</p>', '')
  }
  return {__html: html};
}